import React, { useEffect, useRef } from 'react';
import validator from 'validator';
import {
  Grid,
  Button,
  FormControlLabel,
  Typography,
  Checkbox,
  useMediaQuery,
} from '@mui/material';
import {
  PageContainer,
  InputV2,
  LoadingPage,
  CustomCaptchaComponent,
  RadioGroupCashout,
  ReasonForTransaction,
  InputCurrency,
  PriceLabel,
} from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import createToast from 'components/Toast/Toast';
import theme from 'theme';
import { useNavigate, useParams } from 'react-router-dom';
import WithdrawalDialog from './components/WithdrawalDialog';
import {
  getSheba,
  getCard,
  credit,
  inquiryPaymentAccountNumber,
  configTransfer,
} from '../services/services';
import { useStyles } from './style';
import { useCustomHook } from './constants';
import { debounce } from 'lodash';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
import { useQuery, useCurrencyUnit } from 'hooks';

const CashoutDigital = (props) => {
  const navigate = useNavigate();
  const methods = useForm();
  const { handleSubmit, register, control, formState: { errors }, setValue, formState } = methods;
  const classes = useStyles();
  const paramsId = useParams();
  const captchaRef = useRef();
  const radioGroupCashoutRef = useRef();
  const delayedQuery = useRef(debounce((v, f) => f(v), 500)).current;
  const matches = useMediaQuery('(max-width:600px)');

  const {
    captchaId,
    setCaptchaId,
    enteredCaptcha,
    setEnteredCaptcha,
    saveNumber,
    setSaveNumber,
    isDisable,
    setDisable,
    list,
    setList,
    cardInfoAcc,
    setCardInfoAcc,
    isShow,
    setIsShow,
    openDialog,
    setOpenDialog,
    selectedValue,
    setSelectedValue,
    setIsLoading,
    isLoading,
    role,
    setRole,
    itemNeed,
    setItemNeed,
    inquiryAccount,
    setInquiryAccount,
    isShowLoadingSeach,
    setIsShowLoadingSeach,
    searchText,
    setSearchText,
    limitPrice,
    setLimitPrice,
  } = useCustomHook();
  const query = useQuery();
  const currencyText = useCurrencyUnit();

  useEffect(() => {
    (async () => {
      try {
        radioGroupCashoutRef?.current?.onGetSheba();
        handleCredit();
      } catch (error) {
        console.log(error);
      }
    })();
    getConfigTransferDate();
  }, []);

  useEffect(() => {
    setRole(null);
    setValue('cards', '');
    setSaveNumber(false);
    setInquiryAccount('');
    setFullNameOutFill();
    setSearchText('');
  }, [cardInfoAcc]);

  /**
   * در بعضی جاها نیاز داریم در صورتی که استعلام صورت نگرفته باشه یا تغییری توی انتخاب نوع برداشت صورت گرفته باشد، نام و نام خانوادگی خالی شود
   */
  const setFullNameOutFill = () => {
    setValue('name', '');
    setValue('family', '');
  };

  const getConfigTransferDate = async () => {
    const resultCredit = await configTransfer();
    setLimitPrice(resultCredit?.result);
  };

  const onInputChangeAutoCompelete = (e) => {
    if (!e) return;
    if (e?.type == 'blur') return;
    if (e?.target?.nodeName === 'LI') {
      setSearchText(e?.target?.innerText ?? '');
    } else if (e?.target?.nodeName === 'svg') {
      setSearchText('');
    } else {
      setSearchText(e?.target?.value ?? '');
      delayedQuery(e?.target?.value, onSearchText);
    }
  };

  const onChangeValueAutoCompelete = (newValue) => {
    setRole(newValue);
    if (newValue) {
      inquiry(newValue);
    } else {
      setInquiryAccount('');
      setFullNameOutFill();
      setValue('cards', '');
    }
  };
  useEffect(() => {
    setCardInfoAcc('SETTLEMENT_TOOL_PAYA');
  }, []);
  useEffect(() => {
    setValue('captchaAnswer', enteredCaptcha);
  }, [enteredCaptcha]);

  /**
   * با آیدی که توی یو آر ال فرستاده شده ، اطلاعات حساب رو بدست میاریم و در بقیه قسمت های این صفحه استفاده میکنیم
   */
  const handleCredit = async () => {
    const resultCredit = await credit();
    const accountDetails = {
      wallets: resultCredit?.result?.customerAmountSrvs,
      guilds: resultCredit?.result?.mainBusinessAmountSrvs,
    };
    const itemWallets = accountDetails.wallets.map((item) => ({
      label: `حساب دیجیتال ${item.walletName}`,
      value: item.wallet,
      id: item.id,
      amount: item.amount,
      withdrawableAmount: item?.withdrawableAmount ?? 0,
    }));

    const itemN = itemWallets.filter((item) => {
      if (item?.id == paramsId?.id) {
        return item;
      }
    });
    setItemNeed(itemN);
  };

  /**
   *  فیلد مقصد انتخاب شود یا تغییر کند این تابع کال میشود
   */
  const inquiry = async (inputValue) => {
    setFullNameOutFill();
    const isSheba =
      cardInfoAcc === 'SETTLEMENT_TOOL_PAYA' || cardInfoAcc === 'SETTLEMENT_TOOL_SATNA'
        ? true
        : false;
    if (isSheba) {
      if (
        (inputValue?.inputValue?.length !== 24 || !validator.isNumeric(inputValue?.inputValue)) &&
        String(inputValue?.label).includes('افزودن')
      ) {
        captchaRef?.current?.onMakeCaptcha();
        createToast('خطا', `شماره شبا مقصد باید ۲۴ عدد (بدون عبارت IR) باشد.`, 'danger');
        return;
      }
    } else if (
      (inputValue?.inputValue?.length !== 16 || !validator.isNumeric(inputValue?.inputValue)) &&
      String(inputValue?.label).includes('افزودن')
    ) {
      captchaRef?.current?.onMakeCaptcha();

      createToast('خطا', `شماره کارت مقصد باید ۱۶ عدد و بدون کاراکتر‌های اضافی باشد.`, 'danger');

      return;
    }
    try {
      const res = await inquiryPaymentAccountNumber(inputValue?.inputValue || inputValue?.value);
      setInquiryAccount(res.result.owner);
      if (res?.result?.owner) {
        let splitFullName = String(res.result.owner).trim().split(' ');
        splitFullName.length == 1 && splitFullName.push('—');
        setValue('name', splitFullName[0]);
        splitFullName.shift();
        splitFullName = splitFullName.filter((a) => a != '');
        setValue('family', splitFullName.join(' '));
      } else {
        setFullNameOutFill();
        captchaRef?.current?.onMakeCaptcha();

        createToast(
          'خطا',
          'استعلام انجام نشد لطفا اطلاعات کارت یا شبا موردنظر خود را بررسی کنید.',
          'danger',
        );

        setFullNameOutFill();
      }

      return inquiryAccount;
    } catch {
      setFullNameOutFill();
      captchaRef?.current?.onMakeCaptcha();

      setFullNameOutFill();
    }
  };

  /**
   * کمبوباکس مقصد هر زمان سرچ میشود این تابع کال میشود
   */
  const onSearchText = async (text) => {
    if (!text) return;
    const isValidNumber = validator.isNumeric(text); // چک میکند متن وارد شده عددی هست یا تکس
    if (cardInfoAcc === 'SETTLEMENT_TOOL_CARD') {
      // نوع برداشت از نوع کارت باشد
      if (String(text).length < 16 && isValidNumber) return;
    } else {
      // نوع برداشت پایا و ساتنا باشد
      if (String(text).length < 24 && isValidNumber) return;
    }

    if (cardInfoAcc === 'SETTLEMENT_TOOL_CARD') {
      if (
        list.dataCard.find((a) => a.label === text) ||
        list.dataCard.find((a) => String(a.label).includes(text)) ||
        list.dataCard.find((a) => a.value === text) ||
        list.dataCard.find((a) => String(a.value).includes(text))
      ) {
        // چک میکند اگه متن وارد توی لیست ما وجود دارد، سرچ سرویسی انجام ندهد
        return;
      }
    } else {
      if (
        list.dataSheba.find((a) => a.label === text) ||
        list.dataSheba.find((a) => a.value === text) ||
        list.dataSheba.find((a) => String(a.label).includes(text)) ||
        list.dataSheba.find((a) => String(a.value).includes(text))
      ) {
        // چک میکند اگه متن وارد توی لیست ما وجود دارد، سرچ سرویسی انجام ندهد
        return;
      }
    }
    try {
      setIsShowLoadingSeach(true);
      let params = { offset: 0, size: 50 };

      if (cardInfoAcc === 'SETTLEMENT_TOOL_CARD') {
        // سرچ از نوع کارت ها
        isValidNumber && (params['cardNumber'] = text);
        !isValidNumber && (params['name'] = text);
        const cardData = await getCard(params);
        const cs = cardData.map((sh) => {
          return {
            label: sh?.name ? `${sh.number} - ${sh?.name}` : sh.number,
            value: sh.number,
          };
        });
        const dataList = { dataSheba: [...list.dataSheba], dataCard: [...list.dataCard, ...cs] };
        setList(dataList);
      } else {
        //  سرچ از نوع شبا
        isValidNumber && (params['sheba'] = text);
        !isValidNumber && (params['name'] = text);
        const shebaData = await getSheba(params);
        const ds = shebaData.result.map((res) => {
          return {
            label: res?.name ? `IR${res.shebaNumber} - ${res?.name}` : `IR${res.shebaNumber}`,
            value: res.shebaNumber,
          };
        });

        const dataList = { dataSheba: [...list.dataSheba, ...ds] };
        setList(dataList);
      }
      setIsShowLoadingSeach(false);
    } catch (error) {
      setIsShowLoadingSeach(false);
    }
  };

  const onSubmit = (tempData) => {
    const reasonField = methods.getValues();
    const data = { ...tempData };
    data.cardInfoAcc = cardInfoAcc;
    const isSheba =
      cardInfoAcc === 'SETTLEMENT_TOOL_PAYA' || cardInfoAcc === 'SETTLEMENT_TOOL_SATNA';
    const target = isSheba ? 'شبا' : 'کارت';
    if (!data.cards) {
      captchaRef?.current?.onMakeCaptcha();

      createToast('خطا', `شماره ${target} مقصد را وارد کنید.`, 'danger');

      return;
    }
    const targetNumberValue = data.cards?.value ?? data.cards;
    if (isSheba) {
      if (targetNumberValue.length !== 24 || !validator.isNumeric(targetNumberValue)) {
        captchaRef?.current?.onMakeCaptcha();

        createToast('خطا', `شماره شبا مقصد باید ۲۴ عدد (بدون عبارت IR) باشد.`, 'danger');

        return;
      }
    } else if (targetNumberValue.length !== 16 || !validator.isNumeric(targetNumberValue)) {
      captchaRef?.current?.onMakeCaptcha();

      createToast('خطا', `شماره کارت مقصد باید ۱۶ عدد و بدون کاراکتر‌های اضافی باشد.`, 'danger');

      return;
    }
    if (!data.price) {
      captchaRef?.current?.onMakeCaptcha();
    } else if (
      data.cardInfoAcc !== 'SETTLEMENT_TOOL_CARD' &&
      data.cardInfoAcc !== 'SETTLEMENT_TOOL_PAYA' &&
      data.cardInfoAcc !== 'SETTLEMENT_TOOL_SATNA'
    ) {
      captchaRef?.current?.onMakeCaptcha();
    } else {
      setOpenDialog(true);
      setSelectedValue({
        wallet: itemNeed[0].value,
        amount: data.price,
        toolCode: data.cardInfoAcc,
        toolId: data.cards,
        uniqueId: data.uniqeId,
        captchaId,
        reason: reasonField?.ReasonForTransaction?.value || null,
        captchaAnswer: tempData?.captchaAnswer,
        numberName: data?.numberName,
        description: data?.description,
        paymentId: data?.paymentId,
        name: data?.name,
        family: data?.family,
      });
    }
  };

  /**
   * تکس باکس مبلغ مقداری پر کنیم و بسته به مقداری که وارد کردیم این شروط اعلام میشود
   */

  const disableItems = (amount) => {
    const { card, paya, satna } = limitPrice?.tools;

    // بررسی فعال/غیرفعال بودن هر ابزار با توجه به بازه خودش
    const cardValid = amount >= card.minAmount && amount <= card.maxAmount;
    const payaValid = amount >= paya.minAmount && amount <= paya.maxAmount;
    const satnaValid = amount >= satna.minAmount && amount <= satna.maxAmount;

    // انتخاب ابزار
    if (cardValid) {
      setValue('cardInfoAcc', 'SETTLEMENT_TOOL_CARD');
      setCardInfoAcc('SETTLEMENT_TOOL_CARD');

      if (!list?.dataCard) {
        radioGroupCashoutRef?.current?.onGetCardData();
      }
    } else if (payaValid) {
      setValue('cardInfoAcc', 'SETTLEMENT_TOOL_PAYA');
      setCardInfoAcc('SETTLEMENT_TOOL_PAYA');
    } else if (satnaValid) {
      setValue('cardInfoAcc', 'SETTLEMENT_TOOL_SATNA');
      setCardInfoAcc('SETTLEMENT_TOOL_SATNA');
    }

    // disable بر اساس بازه خودشون فقط
    setDisable({
      isCardDisable: !cardValid,
      isPayaDisable: !payaValid,
      isSatnaDisable: !satnaValid,
    });
  };

  /**
   * بستن دیالوگ نهایی برداشت
   */
  const handleCloseDialog = () => {
    setOpenDialog(false);
    captchaRef?.current?.onMakeCaptcha();
  };

  /**
   * نوع برداشت رادیو باتن که تغییر میکنه  ، این تابع کال میشود
   */
  const handleWithdrawal = (e) => {
    setIsShow(true);
    setCardInfoAcc(e.target.value);
    setRole({ label: '', value: '' });
    setValue('name', '');
    setValue('family', '');
  };

  /**
   *  موجودی حساب فعلی رو که بالای صفحه نمایش میدهیم از این تابع استفاده میکنیم
   */
  const getWithdrawableAmount = () => {
    const wallets = [...itemNeed];
    if (wallets.length === 0) return 0;
    return wallets[0]?.amount ?? 0;
  };

  const actionsList = getDynamicObjectAction(['withdrawAccountBtn', 'withdrawImprestAccountBtn']);

  const hintText =
    'در این قسمت میتوانید مبلغ مورد نظر جهت برداشت وجه را وارد و درخواست خود را ارسال نمایید. پس از تایید‌، مبلغ درخواست داده شده به حساب مقصد واریز خواهد شد.';

  const getKeyBreadCrumbsWithUrl = () => {
    return String(query.get('sourceMenu')).toUpperCase().includes('IMPREST')
      ? constBreadCrumbsTitle.IMPREST_WALLET_CASHOUT
      : constBreadCrumbsTitle.WALLET_CASHOUT;
  };
  return (
    <PageContainer
      title={`ثبت درخواست برداشت وجه: ${itemNeed.length > 0 ? itemNeed[0].label : ''}`}
      description={hintText}
      breadcrumbs={getKeyBreadCrumbsWithUrl()}
      className={classes.root}
    >
      {(actionsList['withdrawAccountBtn'] || actionsList['withdrawImprestAccountBtn']) && (
        <>
          {isLoading && <LoadingPage />}

          <Grid style={isLoading ? { display: 'none' } : {}} item xs={12}>
            <Typography variant="h6" gutterBottom>
              موجودی قابل برداشت از حساب "{itemNeed.length > 0 && itemNeed[0].label}" :{' '}
              <PriceLabel amount={getWithdrawableAmount()} currency={currencyText}/>
            </Typography>
            <FormProvider {...methods}>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className={classes.formContent}
                noValidate
                autoComplete="off"
              >
                <Grid container alignItems="flex-end">
                  <Grid className={classes.grid} item xs={12} md={4}>
                    <InputCurrency
                      fullWidth
                      label="مبلغ"
                      errors={errors}
                      name="price"
                      control={control}
                      register={register}
                      dir="ltr"
                      onChangeValue={disableItems}
                      decimalPlaces={0}
                      minimumValue={0}
                      rules={['required']}
                    />
                  </Grid>
                </Grid>

                <RadioGroupCashout
                  ref={radioGroupCashoutRef}
                  classes={classes}
                  control={control}
                  errors={errors}
                  register={register}
                  handleWithdrawal={handleWithdrawal}
                  cardInfoAcc={cardInfoAcc}
                  isDisable={isDisable}
                  isShow={isShow}
                  isShowLoadingSeach={isShowLoadingSeach}
                  list={list}
                  setList={setList}
                  setIsLoading={setIsLoading}
                  onInputChangeAutoCompelete={onInputChangeAutoCompelete}
                  onChangeValueAutoCompelete={onChangeValueAutoCompelete}
                />

                <Grid item xs={12} md={4} style={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid className={classes.grid} item xs={12} md={6}>
                    <InputV2
                      fullWidth
                      errors={errors}
                      label="نام"
                      name="name"
                      control={control}
                      register={register}
                      disabled
                      style={{ backgroundColor: 'rgb(241 241 241)' }}
                    />
                  </Grid>
                  <Grid className={classes.grid} item xs={12} md={6} style={{ marginRight: '4px' }}>
                    <InputV2
                      fullWidth
                      errors={errors}
                      label="نام خانوادگی"
                      name="family"
                      control={control}
                      register={register}
                      disabled
                      style={{ backgroundColor: 'rgb(241 241 241)' }}
                    />
                  </Grid>
                </Grid>
                <Grid item lg={4} sm={12} xs={12}>
                  <ReasonForTransaction key={'reasonTransaction10'} />
                </Grid>
                {role?.inputValue ? (
                  <FormControlLabel
                    value={saveNumber}
                    control={
                      <Checkbox
                        color="primary"
                        onChange={(e) => {
                          setSaveNumber(e.target.checked);
                        }}
                        checked={saveNumber}
                        value={saveNumber}
                        icon={<CheckBoxIcon />}
                        checkedIcon={<CheckBoxIconFill />}
                      />
                    }
                    label={`ذخیره شماره ${
                      cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت' : 'شبا'
                    } در لیست ${cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت‌ها' : 'شباها'}`}
                  />
                ) : null}

                {saveNumber ? (
                  <Grid item xs={12} md={4}>
                    <InputV2
                      errors={errors}
                      name="numberName"
                      label={`عنوان ${cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت' : 'شبا'}`}
                      register={register}
                      rules={['required', 'isNotContainTag']}
                      fullWidth
                      control={control}
                    />
                  </Grid>
                ) : null}

                <Grid className={classes.grid} item xs={12} md={4}>
                  <InputV2
                    fullWidth
                    errors={errors}
                    label="شناسه یکتا"
                    name="uniqeId"
                    rules={['isNotContainTag']}
                    control={control}
                    register={register}
                    dir="ltr"
                  />
                </Grid>

                <Grid className={classes.grid} item xs={12} md={4}>
                  <InputV2
                    fullWidth
                    errors={errors}
                    label="شناسه واریز"
                    rules={['isNotContainTag']}
                    name="paymentId"
                    control={control}
                    register={register}
                    dir="ltr"
                  />
                </Grid>

                <Grid className={classes.grid} item xs={12} md={4}>
                  <InputV2
                    fullWidth
                    errors={errors}
                    label="توضیحات"
                    name="description"
                    control={control}
                    register={register}
                    characterLimit={100}
                    rules={['isNotContainTag', 'isLt|100']}
                  />
                </Grid>

                <Grid container wrap={matches ? 'wrap' : 'nowrap'}>
                  <InputV2
                    errors={errors}
                    name="captchaAnswer"
                    label="کد امنیتی"
                    register={register}
                    englishNumber
                    forceValue={enteredCaptcha}
                    onChangeValue={(e) => {
                      const value = e.target.value;
                      if (value.length > 5) {
                        e.preventDefault();
                        setEnteredCaptcha(value.slice(0, 5));
                      } else {
                        setEnteredCaptcha(value);
                      }
                    }}
                    rules={['required', 'isNumeric']}
                    fullWidth
                    dir="ltr"
                    control={control}
                  />
                  <CustomCaptchaComponent
                    ref={captchaRef}
                    setCaptchaId={setCaptchaId}
                    setEnteredCaptcha={setEnteredCaptcha}
                    pageTitle="//CashOut/:id - برداشت وجه"
                  />
                </Grid>

                <Grid container item xs={12} justifyContent="flex-end">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ marginTop: theme.spacing(2) }}
                  >
                    ثبت درخواست تسویه
                  </Button>
                </Grid>
              </form>
            </FormProvider>
          </Grid>

          <WithdrawalDialog
            selectedValue={selectedValue}
            open={openDialog}
            onClose={handleCloseDialog}
            saveAccountNumber={saveNumber}
            navigate={navigate}
            cardInfoAcc={cardInfoAcc}
            limitPrice={limitPrice}
          />
        </>
      )}
    </PageContainer>
  );
};

export default CashoutDigital;
